import { Pipe, PipeTransform } from "@angular/core"
import * as moment from "moment"

@Pipe({
	name: "localtime",
})
export class LocalTimePipe implements PipeTransform {
	transform(time: any) {
		return moment.utc(time).local().format("HH:mm")
	}
}
